import { Button, Stack, Typography } from "@mui/material";
import { BaseModuleSubtype } from "../../../../../../types/actionModule/subtypes/subtype";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Download } from "@mui/icons-material";
import { MultiPictureUploadSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/multiPictureUploadSubtype";

interface Props {
    subtype: BaseModuleSubtype;
    subtypeData: MultiPictureUploadSubtypeDataModel;
}

export default function MultiPictureUploadSubtypeDetails(props: Props) {
    const { t } = useTranslation();

    return <>
        <Typography variant="subtitle1">{t("incentivationPage.multiPictureUpload.uploadedImages")}</Typography>
        <Stack direction="row" sx={{ mb: 2, flexWrap: "wrap", gap: 2 }}>
            {
                props.subtypeData.images.map(i => <img
                    style={{ maxHeight: "400px", maxWidth: "100%", objectFit: "contain" }}
                    src={i.uploadedImageUrl} />)
            }
        </Stack>
        {
            props.subtypeData.bundleDownloadUrl &&
            <Link to={props.subtypeData.bundleDownloadUrl} target="_blank">
                <Button variant="outlined">
                    <Download />
                    {t("incentivationPage.multiPictureUpload.downloadBundle")}
                </Button>
            </Link>
        }
    </>
}
